'use client';

import { c as _c } from "react/compiler-runtime";
import type { RefObject } from 'react';
import { FeatherArrowLeft, FeatherDownload, FeatherPrinter } from '@subframe/core';
import { Button } from '@/shared/components/ui';
import type { SentencaArbitralDados } from '../../../types/sentencaArbitral.types';
import { DocumentoCarregando, DocumentoComErro, DocumentoNaoEncontrado, DocumentoSemPermissao } from '../EstadosDocumento';
import { SentencaArbitralDocumento } from './SentencaArbitralDocumento';
interface SentencaArbitralViewProps {
  sentenca: SentencaArbitralDados | null;
  isLoading: boolean;
  error: string | null;
  semPermissao: boolean;
  naoPublicada: boolean;
  documentoRef: RefObject<HTMLDivElement | null>;
  isDownloadingPdf: boolean;
  onBaixarPdf: () => void;
  onImprimir: () => void;
  onTentarNovamente: () => void;
  onVoltar: () => void;
}
export function SentencaArbitralView(t0) {
  const $ = _c(31);
  const {
    sentenca,
    isLoading,
    error,
    semPermissao,
    naoPublicada,
    documentoRef,
    isDownloadingPdf,
    onBaixarPdf,
    onImprimir,
    onTentarNovamente,
    onVoltar
  } = t0;
  if (semPermissao) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <DocumentoSemPermissao />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (error) {
    let t1;
    if ($[1] !== error || $[2] !== onTentarNovamente) {
      t1 = <DocumentoComErro mensagem={error} onTentarNovamente={onTentarNovamente} />;
      $[1] = error;
      $[2] = onTentarNovamente;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  if (naoPublicada) {
    let t1;
    if ($[4] !== onVoltar) {
      t1 = <DocumentoNaoEncontrado onVoltar={onVoltar} />;
      $[4] = onVoltar;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  if (isLoading || !sentenca) {
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <DocumentoCarregando />;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  let t1;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherArrowLeft />;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== onVoltar) {
    t2 = <Button icon={t1} onClick={onVoltar} variant="neutral-tertiary">Voltar</Button>;
    $[8] = onVoltar;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherPrinter />;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== onImprimir) {
    t4 = <Button icon={t3} onClick={onImprimir} variant="neutral-secondary">Imprimir</Button>;
    $[11] = onImprimir;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherDownload />;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== isDownloadingPdf || $[15] !== onBaixarPdf) {
    t6 = <Button disabled={isDownloadingPdf} icon={t5} loading={isDownloadingPdf} onClick={onBaixarPdf}>Baixar PDF</Button>;
    $[14] = isDownloadingPdf;
    $[15] = onBaixarPdf;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <div className="flex flex-wrap items-center gap-2">{t4}{t6}</div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t2 || $[21] !== t7) {
    t8 = <div className="flex w-full max-w-[794px] flex-wrap items-center justify-between gap-3 pb-5" data-doc-print-hidden={true}>{t2}{t7}</div>;
    $[20] = t2;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== sentenca) {
    t9 = <SentencaArbitralDocumento sentenca={sentenca} />;
    $[23] = sentenca;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== documentoRef || $[26] !== t9) {
    t10 = <div className="w-full max-w-full overflow-x-auto"><div className="mx-auto flex w-fit flex-col gap-6 pb-6" data-doc-print-root={true} ref={documentoRef}>{t9}</div></div>;
    $[25] = documentoRef;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t8) {
    t11 = <div className="flex w-full flex-col items-center bg-neutral-100 px-4 py-6 sm:py-10">{t8}{t10}</div>;
    $[28] = t10;
    $[29] = t8;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}